module.exports = __webpack_public_path__ + "static/img/help_02class_01.08cd9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_01.jpg
// module id = 682
// module chunks = 140